import { useEffect, useRef } from "react";

const CHECK_INTERVAL_MS = 5 * 60 * 1000; // 5 minutes
const INITIAL_CHECK_MS = 30 * 1000; // 30 seconds after mount
const RELOAD_KEY = "pinpoint_version_reload";

export default function useVersionCheck() {
  const currentVersion = useRef(process.env.REACT_APP_SENTRY_RELEASE);

  useEffect(() => {
    // No version baked in — skip (local dev)
    if (!currentVersion.current) return;

    const check = async () => {
      try {
        const res = await fetch("/version.json", { cache: "no-store" });
        if (!res.ok) return;
        const { version } = await res.json();
        if (version && version !== currentVersion.current) {
          // Prevent infinite reload loops — if we already tried reloading
          // for this version and still have a mismatch, stop trying
          const lastAttempt = sessionStorage.getItem(RELOAD_KEY);
          if (lastAttempt === version) return;
          console.info(
            `[Pinpoint] New version detected: ${version} (running ${currentVersion.current}). Reloading.`
          );
          sessionStorage.setItem(RELOAD_KEY, version);
          window.location.reload();
        }
      } catch {
        // Network error — ignore, will retry next interval
      }
    };

    const initialTimer = setTimeout(check, INITIAL_CHECK_MS);
    const id = setInterval(check, CHECK_INTERVAL_MS);
    return () => {
      clearTimeout(initialTimer);
      clearInterval(id);
    };
  }, []);
}
